/* ══════════════════════════════════════════════════════════════
   Tamil (ta) — தமிழ் Translation File
   ══════════════════════════════════════════════════════════════ */

export const ta = {
    app: {
        name: 'இந்தியா மார்க்கெட் மானிட்டர்',
        tagline: 'AI-இயக்கும் இந்திய சந்தை நுண்ணறிவு',
    },
    nav: {
        dashboard: 'டாஷ்போர்டு',
        strategy: 'உத்தி',
        intelligence: 'புலனாய்வு',
        markets: 'சந்தைகள்',
        indiaMap: 'இந்திய வரைபடம்',
        ipoEarnings: 'IPO & வருவாய்',
        backtest: 'பேக்டெஸ்ட்',
        settings: 'அமைப்புகள்',
        search: 'நிறுவனம், செய்திகள் தேடுங்கள்…',
    },
    dashboard: {
        title: 'டாஷ்போர்டு',
        marketStatus: 'சந்தை நிலை',
        open: 'திறந்தது',
        closed: 'மூடியது',
        preOpen: 'முன்-திறப்பு',
        holiday: 'விடுமுறை',
        strategyCard: 'இன்றைய உத்தி',
        marketRadar: 'மார்க்கெட் ரேடார்',
        fiiDii: 'FII / DII ஓட்டம்',
        quickStats: 'விரைவு புள்ளிவிவரங்கள்',
        newsTicker: 'முன்னுரிமை செய்திகள்',
        liveTV: 'நேரடி டிவி',
        viewDetails: 'விவரங்கள் →',
        updatedAt: '{{time}} இல் புதுப்பிக்கப்பட்டது',
    },
    strategy: {
        title: 'உத்தி',
        regime: 'சந்தை நிலை',
        regimeTypes: {
            trendingBull: 'ஏறுமுகம்',
            trendingBear: 'இறங்குமுகம்',
            sideways: 'பக்கவாட்டு',
            highVol: 'அதிக ஏற்ற இறக்கம்',
        },
        confidence: 'நம்பிக்கை',
        entry: 'நுழைவு',
        target: 'இலக்கு',
        stopLoss: 'ஸ்டாப் லாஸ்',
        signal: 'சிக்னல்',
        buy: 'வாங்கு',
        sell: 'விற்கவும்',
        hold: 'வைத்திரு',
        featureImportance: 'அம்ச முக்கியத்துவம்',
        keyLevels: 'முக்கிய நிலைகள்',
        support: 'ஆதரவு',
        resistance: 'எதிர்ப்பு',
        currentPrice: 'தற்போதைய விலை',
    },
    intelligence: {
        title: 'புலனாய்வு',
        morningBrief: 'காலை சுருக்கம்',
        priorityFeed: 'முன்னுரிமை ஊட்டம்',
        sectorIntel: 'துறை புலனாய்வு',
        earningsTracker: 'வருவாய்',
        eventTimeline: 'நிகழ்வுகள்',
        newsSearch: 'தேடல்',
        sentiment: 'கருத்து',
        bullish: 'ஏறுமுகம்',
        bearish: 'இறங்குமுகம்',
        neutral: 'நடுநிலை',
    },
    markets: {
        title: 'சந்தைகள்',
        indices: 'குறியீடுகள்',
        options: 'ஆப்ஷன்ஸ்',
        sectors: 'துறைகள்',
        commodities: 'பொருட்கள்',
        currency: 'நாணயம்',
        breadth: 'அகலம்',
        advancing: 'முன்னேறும்',
        declining: 'சரியும்',
        unchanged: 'மாற்றமில்லை',
    },
    ipo: {
        title: 'IPO & வருவாய்',
        dashboard: 'IPO டாஷ்போர்டு',
        earningsTracker: 'வருவாய் கண்காணிப்பு',
        upcoming: 'வரவிருக்கும் IPO',
        subscribe: 'சந்தா',
        avoid: 'தவிர்க்கவும்',
        revenue: 'வருவாய்',
        verdict: 'தீர்ப்பு',
        beat: 'தாண்டியது',
        miss: 'தவறியது',
    },
    backtest: {
        title: 'பேக்டெஸ்ட்',
        equityCurve: 'ஈக்விட்டி வளைவு',
        riskMetrics: 'ரிஸ்க் மெட்ரிக்ஸ்',
        monthlyReturns: 'மாதாந்திர வருமானம்',
        tradeLog: 'வர்த்தக பதிவு',
        totalReturn: 'மொத்த வருமானம்',
        winRate: 'வெற்றி விகிதம்',
    },
    map: {
        title: 'இந்திய வரைபடம்',
        selectState: 'மாநிலத்தைத் தேர்ந்தெடுக்கவும்',
        gdp: 'GDP',
        growth: 'வளர்ச்சி',
        keySectors: 'முக்கிய துறைகள்',
    },
    settings: {
        title: 'அமைப்புகள்',
        language: 'மொழி',
        selectLanguage: 'மொழியைத் தேர்ந்தெடுக்கவும்',
        darkMode: 'இருண்ட பயன்முறை',
        lightMode: 'ஒளி பயன்முறை',
    },
    sectorRotation: {
        title: 'துறை சுழற்சி',
        leading: 'முன்னணி',
        weakening: 'பலவீனம்',
        lagging: 'பின்தங்கிய',
        improving: 'மேம்படுதல்',
    },
    election: {
        title: 'தேர்தல் தாக்கம்',
        upcomingElections: 'வரவிருக்கும் தேர்தல்கள்',
        state: 'மாநிலம்',
        historicalImpact: 'வரலாற்று நிஃப்டி தாக்கம்',
        avgReturn: 'சராசரி நிஃப்டி வருமானம்',
    },
    budget: {
        title: 'பட்ஜெட் தாக்கம்',
        unionBudget: 'மத்திய பட்ஜெட் 2026-27',
        daysLeft: '{{days}} நாட்கள் மீதம்',
        sectorAllocation: 'துறை ஒதுக்கீடு மாற்றங்கள்',
        increase: 'அதிகரிப்பு',
        decrease: 'குறைப்பு',
    },
    common: {
        loading: 'ஏற்றுகிறது…',
        error: 'ஏதோ தவறு நடந்தது',
        retry: 'மீண்டும் முயற்சி',
        noData: 'தரவு இல்லை',
        viewAll: 'அனைத்தும் காண்க',
        close: 'மூடு',
        save: 'சேமி',
        cancel: 'ரத்து',
        crore: 'கோடி',
        lakh: 'லட்சம்',
        rupee: '₹',
        disclaimer: 'இது நிதி ஆலோசனை அல்ல. தகவல் நோக்கத்திற்காக மட்டுமே.',
    },
};
